import { createOccurrenceAmenitiesAPI } from "../api/apiFactory";
import type { IOccurrenceAmenitiesAPI } from "../api/occurrenceAmenitiesApi";
import type { OccurrenceAmenities } from "../types/OccurrenceAmenities";

/** R27 — per-occurrence amenity changes (hearth/docs/BOOKING_RULES.md#r27). */
export class OccurrenceAmenityService {
  private api: IOccurrenceAmenitiesAPI;

  constructor(api?: IOccurrenceAmenitiesAPI) {
    this.api = api || createOccurrenceAmenitiesAPI();
  }

  getOccurrenceAmenities(bookingId: string): Promise<OccurrenceAmenities[]> {
    return this.api.fetchOccurrenceAmenities(bookingId);
  }

  setOccurrenceAmenities(bookingId: string, dates: string[], amenityIds: string[]): Promise<void> {
    return this.api.setOccurrenceAmenities(bookingId, dates, amenityIds);
  }

  resetOccurrenceAmenities(bookingId: string, dates: string[]): Promise<void> {
    return this.api.resetOccurrenceAmenities(bookingId, dates);
  }
}
